module.exports = __webpack_public_path__ + "static/media/step_2.e3d32d34.png";